import { Container, Text } from './EmailSuccessfullySent.styles';
import { Button } from '@welbe/design-system';
import React from 'react';

interface IEmailSuccessfullySent {
	onClose: () => void;
	email: string;
}

export const EmailSuccessfullySent = ({
	onClose,
	email,
}: IEmailSuccessfullySent): JSX.Element => {
	return (
		<Container>
			<h3>Código enviado</h3>
			<div>
				<Text>Enviamos a tu correo</Text>
				<Text>
					<strong>{email}</strong>
				</Text>
				<Text> un código, no olvides revisar en la carpeta de SPAM.</Text>
			</div>
			<Button onClick={onClose}>Ok</Button>
		</Container>
	);
};
